import ValueGeneratorInterface from "./ValueGeneratorInterface"
import ValueInterface from "../../Model/Value/ValueInterface"
import NumberValue from "../../Model/Value/NumberValue"

export default class NumberValueGenerator implements ValueGeneratorInterface {
  public supports(_: number, level: number): boolean {
    return level < 2
  }

  public generate(value: number): ValueInterface {
    return new NumberValue(value)
  }
}
